var _defs, _rect, _rect2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderMock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "f5125e3054"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0ecffb503e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.871094 31.265625 L 260.636719 31.265625 L 260.636719 150 L 41.871094 150 Z M 41.871094 31.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f409bb61e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.621094 31.265625 L 253.816406 31.265625 C 255.605469 31.265625 257.320312 31.976562 258.585938 33.242188 C 259.855469 34.507812 260.566406 36.222656 260.566406 38.015625 L 260.566406 162.117188 C 260.566406 163.90625 259.855469 165.625 258.585938 166.890625 C 257.320312 168.15625 255.605469 168.867188 253.816406 168.867188 L 48.621094 168.867188 C 46.828125 168.867188 45.113281 168.15625 43.847656 166.890625 C 42.582031 165.625 41.871094 163.90625 41.871094 162.117188 L 41.871094 38.015625 C 41.871094 36.222656 42.582031 34.507812 43.847656 33.242188 C 45.113281 31.976562 46.828125 31.265625 48.621094 31.265625 Z M 48.621094 31.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "fb1a1e17e5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#f5125e3054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#000000",
    y: -15,
    height: 179.999997,
    fillOpacity: 0.65
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "8a3f89815d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.570312 0.265625 L 243.425781 0.265625 L 243.425781 25.484375 L 0.570312 25.484375 Z M 0.570312 0.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e3fe00fca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.320312 0.265625 L 236.65625 0.265625 C 238.449219 0.265625 240.164062 0.976562 241.429688 2.242188 C 242.695312 3.507812 243.40625 5.222656 243.40625 7.015625 L 243.40625 18.734375 C 243.40625 20.527344 242.695312 22.242188 241.429688 23.507812 C 240.164062 24.773438 238.449219 25.484375 236.65625 25.484375 L 7.320312 25.484375 C 5.527344 25.484375 3.8125 24.773438 2.546875 23.507812 C 1.28125 22.242188 0.570312 20.527344 0.570312 18.734375 L 0.570312 7.015625 C 0.570312 5.222656 1.28125 3.507812 2.546875 2.242188 C 3.8125 0.976562 5.527344 0.265625 7.320312 0.265625 Z M 7.320312 0.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3f3d08f791"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 244,
    y: 0,
    height: 26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "275fb11f2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.414062 36.691406 L 89.105469 36.691406 L 89.105469 51.058594 L 48.414062 51.058594 Z M 48.414062 36.691406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "406c0a2cca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.164062 36.691406 L 82.339844 36.691406 C 84.128906 36.691406 85.847656 37.402344 87.113281 38.667969 C 88.378906 39.933594 89.089844 41.652344 89.089844 43.441406 L 89.089844 44.308594 C 89.089844 46.101562 88.378906 47.816406 87.113281 49.082031 C 85.847656 50.347656 84.128906 51.058594 82.339844 51.058594 L 55.164062 51.058594 C 53.375 51.058594 51.65625 50.347656 50.390625 49.082031 C 49.125 47.816406 48.414062 46.101562 48.414062 44.308594 L 48.414062 43.441406 C 48.414062 41.652344 49.125 39.933594 50.390625 38.667969 C 51.65625 37.402344 53.375 36.691406 55.164062 36.691406 Z M 55.164062 36.691406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a0adaac1da"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#f5125e3054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#000000",
    y: -15,
    height: 179.999997,
    fillOpacity: 0.65
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e1e255ab49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.417969 0.417969 L 206.097656 0.417969 L 206.097656 71 L 0.417969 71 Z M 0.417969 0.417969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be0d52560a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.167969 0.417969 L 199.316406 0.417969 C 203.042969 0.417969 206.066406 3.4375 206.066406 7.167969 L 206.066406 64.25 C 206.066406 67.976562 203.042969 71 199.316406 71 L 7.167969 71 C 3.4375 71 0.417969 67.976562 0.417969 64.25 L 0.417969 7.167969 C 0.417969 3.4375 3.4375 0.417969 7.167969 0.417969 Z M 7.167969 0.417969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "43c1293b3a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 207,
    y: 0,
    height: 72
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#edeaea",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ecffb503e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f409bb61e8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.871094 31.265625 L 260.636719 31.265625 L 260.636719 168.867188 L 41.871094 168.867188 Z M 41.871094 31.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fb1a1e17e5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 27, 31)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3f3d08f791)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8a3f89815d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e3fe00fca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M 0.570312 0.265625 L 243.425781 0.265625 L 243.425781 25.484375 L 0.570312 25.484375 Z M 0.570312 0.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#275fb11f2d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#406c0a2cca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59a3ff",
    d: "M 48.414062 36.691406 L 89.105469 36.691406 L 89.105469 51.058594 L 48.414062 51.058594 Z M 48.414062 36.691406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a0adaac1da)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 48, 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#43c1293b3a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e1e255ab49)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be0d52560a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#edeaea",
    d: "M 0.417969 0.417969 L 206.097656 0.417969 L 206.097656 71 L 0.417969 71 Z M 0.417969 0.417969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMock);
export default __webpack_public_path__ + "static/media/headerMock.e6fe22012e2901d42f09df17fd6dc1a5.svg";
export { ForwardRef as ReactComponent };